import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import ConsultInternalButton from './ConsultInternalButton';

export function InvoiceConsultInternal() {
  const {
    isNfe,
    isNfc,
    isNfs,
    isInternalApiIssued,
    useInternalInvoiceApiNfe,
    useInternalInvoiceApiNfc,
    useInternalInvoiceApiNfs,
  } = useInvoiceFormContext();

  if (isNfe && (useInternalInvoiceApiNfe || isInternalApiIssued)) {
    return <ConsultInternalButton type={InvoiceType.NFE} />;
  }

  if (isNfc && (useInternalInvoiceApiNfc || isInternalApiIssued)) {
    return <ConsultInternalButton type={InvoiceType.NFC} />;
  }

  if (isNfs && (useInternalInvoiceApiNfs || isInternalApiIssued)) {
    return <ConsultInternalButton type={InvoiceType.NFS} />;
  }

  return null;
}
